import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  gap: 35px;
`;

export const Field = styled.div`
  flex: 1;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  color: #666;
  font-weight: 700;
`;

export const Required = styled.span`
  color: #e30613;
`;

export const Input = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 15px;
  border: none;
  background-color: #ececec !important;
  color: #666666 !important;
  padding: 0 15px;
  outline: none;
  font-size: 14px;
  color: #666;

  &:focus {
    border: 2px solid #e30613;
  }
`;

export const SubmitButton = styled.button`
  background-color: #e30613;
  width: 100%;
  height: 50px;
  color: white;
  border: none;
  border-radius: 8px; /* Redondeado para suavizar el diseño */
  cursor: pointer;
  margin: 10px 0;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2); /* Agrega sombra */

  &:hover {
    background-color: #d62828; /* Un rojo más oscuro */
    transform: scale(1.05); /* Leve agrandamiento al pasar el mouse */
  }
`;

export const BackButton = styled.button`
  background-color: #f0f0f0;
  color: #666;
  border: 1px solid #ccc;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 5px;
  &:hover {
    background-color: #e0e0e0;
  }
`;


export const StyledPriceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f8f8;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

export const StyledPrice = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #e30613;
`;